// extracted by mini-css-extract-plugin
export default {"container":"OnboardProgressBar_container__t0wqo","mobile-container":"OnboardProgressBar_mobile-container__72kil"};